import { isRoleAuditoriaNsir } from './auditoriaNsirPermission';
import { isUUID } from '../utils';

/**
 * Rotas permitidas para usuário com ROLE_AUDITORIA_NSIR (navegação e URL direta).
 */
export function isPathPermitidoAuditoriaNsir(pathname) {
  if (pathname === '/meu-perfil') return true;
  if (pathname === '/nsirs') return true;
  if (pathname === '/procedimentos-normas') return true;
  if (pathname === '/nsir') return false;
  if (pathname.startsWith('/nsir/')) {
    const rest = pathname.slice('/nsir/'.length);
    const segment = rest.split('/')[0];
    return Boolean(segment && isUUID(segment));
  }
  return false;
}

/**
 * Se deve redirecionar para /nsirs (usuário logado, role auditor, rota não permitida).
 */
export function deveRedirecionarAuditoriaNsir({ isLogado, pathname, userRole }) {
  if (!isLogado || !userRole) return false;
  if (!isRoleAuditoriaNsir(userRole)) return false;
  return !isPathPermitidoAuditoriaNsir(pathname);
}
